import React, { useEffect } from "react";
import ReactDOM from 'react-dom';
import { motion } from "framer-motion";
import { useInView } from "react-intersection-observer";
import $ from "jquery"; // Import jQuery
import CustomNeed from "../component/CustomNeed";

const WireframingPrototyping = () => {
    useEffect(() => {
    
        const win = window;
    
        function isElementVisible($el) {
          const viewTop = win.scrollY;
          const viewBottom = viewTop + window.innerHeight;
          const elTop = $el.offset().top;
          const elBottom = elTop + $el.height();
          return elBottom <= viewBottom && elTop >= viewTop;
        }
        $('.why_coustom_app').parents('body').find('header').addClass('white_header');  
        function addAnimation($el, delay) {
            
          setTimeout(() => {
            $el.addClass("come-in");
            $el.attr("class", "webflow_circle come-in");
          }, delay);
        }
    
        const allMods1 = Array.from(document.querySelectorAll(".webflow_circle"));
        const allMods2 = Array.from(document.querySelectorAll(".html_circle"));
        const allMods3 = Array.from(document.querySelectorAll(".css_circle"));
        const allMods4 = Array.from(document.querySelectorAll(".js_circle"));
    
        win.addEventListener("scroll", () => {
          allMods1.forEach((el, i) => {
            const $el = $(el);
            if (isElementVisible($el)) {
              addAnimation($el, i * 200);
            }
          });
    
          allMods2.forEach((el, i) => {
            const $el = $(el);
            if (isElementVisible($el)) {
              addAnimation($el, i * 200);
            }
          });
    
          allMods3.forEach((el, i) => {
            const $el = $(el);
            if (isElementVisible($el)) {
              addAnimation($el, i * 200);
            }
          });
    
          allMods4.forEach((el, i) => {
            const $el = $(el);
            if (isElementVisible($el)) {
              addAnimation($el, i * 200);
            }
          });
        });
    
        const handleScroll = () => {
          const offset = window.pageYOffset;
          const wheight = window.innerHeight;
          const html = document.documentElement;
          const docheight = Math.max(
            document.body.scrollHeight,
            document.body.offsetHeight,
            html.clientHeight,
            html.scrollHeight,
            html.offsetHeight
          );
          let progress = (offset / (docheight - wheight)) * 3000;
    
          // Give the line a CSS gradient based on scroll position
          progress = 3000 - progress * 1.6;
    
          // Update the SVG element with the new stroke-dashoffset
          const fillingPath = document.getElementById("filling_path");
          if (fillingPath) {
            fillingPath.setAttribute("stroke-dashoffset", progress);
          }
        };
    
        // Add scroll event listener when the component mounts
        window.addEventListener("scroll", handleScroll);
    
        // Remove the event listener when the component unmounts
        return () => {
            
          window.removeEventListener("scroll", handleScroll); 
        };
      }, []);
      const [ref, inView] = useInView({
        triggerOnce: true, // Ensures the animation occurs only once
        threshold: 0.2, // Change as needed; it's the percentage of the element's visibility to trigger the animation
      });
    
      const leftAnimation = {
        hidden: { opacity: 0, scale: 0, x: -200 },
        visible: {
          opacity: 1,
          scale: 1,
          x: 0,
          transition: { duration: 1, ease: "easeOut" }, // Define your desired animation properties
        },
      };
    
      const image1Animation = {
        hidden: { opacity: 0, scale: 0, x: -200 },
        visible: {
          opacity: 1,
          scale: 1,
          x: 0,
          transition: { duration: 1, ease: "easeOut", delay: 0.5 }, // Define your desired animation properties
        },
      };
    
      const image2Animation = {
        hidden: { opacity: 0, scale: 0, x: -200 },
        visible: {
          opacity: 1,
          scale: 1,
          x: 0,
          transition: { duration: 1, ease: "easeOut", delay: 1 }, // Define your desired animation properties
        },
      };
    
      const image3Animation = {
        hidden: { opacity: 0, scale: 0, x: -200 },
        visible: {
          opacity: 1,
          scale: 1,
          x: 0,
          transition: { duration: 1, ease: "easeOut", delay: 1.5 }, // Define your desired animation properties
        },
      };
       
      return (
        <>
          <div
            className="inner_banner service-banner"
            style={{ backgroundImage: "url(/assets/images/site/uiux-2.png)" }}
          >
            <div className="wrapper">
              <div className="banner_detail_1">
                <div className="details-ser">
                  <h1 id="heading_line">Wireframing & Prototyping Services: Bringing Your Ideas to Life</h1>
                  <h2 id="sub_heading1">
                  At Codeflix, we specialize in Wireframing & Prototyping services to help businesses transform their ideas into fully functional and user-friendly digital experiences. Our team ensures that your product is designed with precision, usability, and efficiency, reducing development costs and improving user satisfaction.
                  </h2>
                </div>
              </div>
            </div>
          </div>
          <div className="why_coustom_app">
            <div className="wrapper">
              <h3>
              Why Choose Our  <span>Wireframing & Prototyping Services ?</span>
              </h3>
              <h4>1.User-Centered Design Approach:</h4>
              <p>We focus on your target audience to create intuitive and engaging designs.</p>
              <h4>2.	Iterative Testing & Validation: </h4>
              <p>Early-stage usability testing ensures minimal redesign and maximum efficiency.</p>
              <h4>3.	Collaboration & Transparency: </h4>
              <p>We work closely with your team to align product goals with design outcomes.</p>
              <h4>4.	Cost-Effective Solutions: </h4>
              <p>Early-stage visualization reduces unnecessary development expenses.</p>
              <h4>5.	Scalable & Adaptive Designs: </h4>
              <p>We create designs that can grow and evolve with your business needs.</p>
              <h4>6.	Enhanced User Experience: </h4>
              <p>Our wireframes and prototypes ensure a seamless and engaging user journey.</p>
              <h3><span>Our Wireframing Process</span></h3>
            <ul>
                <h4>1. Understanding User Needs</h4>
                <li>We conduct in-depth user research to define goals, pain points, and requirements.</li>
                <li>Using user personas and customer journey mapping, we create tailored experiences.</li>
                <h4>2. Sketching Initial Wireframes</h4>
                <li>Our experts create rough layouts to structure user interfaces and workflows.</li>
                <li>We ensure accessibility and responsive design principles are integrated from the start.</li>
                <h4>3. Creating High-Fidelity Wireframes</h4>
                <li>We refine designs using industry-leading tools like Figma, Sketch, and Adobe XD to create detailed blueprints.</li>
                <li>Wireframes are designed with scalability and performance optimization in mind.</li>
            </ul>
            <h3><span>Our Prototyping Services</span></h3>
            <ul>
                <h4>1. Interactive Prototyping</h4>
                <li>We bring static designs to life by adding interactivity and navigation features.</li>
                <li>Our prototypes allow for real-time collaboration and user testing.</li>
                <h4>2. Usability Testing & Feedback</h4>
                <li>Our team conducts usability testing to identify improvements before development begins.</li>
                <li>We incorporate heatmaps, A/B testing, and analytics to ensure optimal design decisions.</li>
                <h4>3. Iterative Refinements</h4>
                <li>Based on real-user feedback, we optimize and enhance the design for the best user experience.</li>
                <li>We implement data-driven design improvements to enhance usability and engagement.</li>
            </ul>
            <h3><span>Tools We Use</span></h3>
                <ul>
                    <li><b>Figma – </b>Collaborative design and prototyping</li>
                    <li><b>InVision –</b>Seamless prototyping and team collaboration</li>
                    <li><b>Adobe XD – </b>End-to-end UI/UX design</li>
                    <li><b>Axure RP – </b>Advanced prototyping with logic-based interactions</li>
                    <li><b>Balsamiq – </b>Quick low-fidelity wireframing for rapid ideation</li>
                    <li><b>Marvel App – </b>Interactive prototyping for fast user validation</li>
                </ul>
                <h3><span>Industries We Serve</span></h3>
                <ul>
                    <p>Our Wireframing & Prototyping Services cater to a wide range of industries, including:</p>
                    <li><b>E-commerce & Retail – </b>Optimized interfaces for smooth shopping experiences.</li>
                    <li><b>Healthcare –</b>Intuitive designs that prioritize accessibility and compliance.</li>
                    <li><b>Finance & Banking – </b>Secure and user-friendly interfaces for financial platforms.</li>
                    <li><b>Education & E-learning –</b>Engaging and interactive learning experiences.</li>
                    <li><b>Technology & Startups – </b>Scalable prototypes for innovative product launches.</li>
                </ul>
                <h3><span>Get Started with Us!</span></h3>
                <p>Are you looking to build a product that stands out with a seamless user experience? Our Wireframing & Prototyping Services ensure that your digital product is functional, intuitive, and ready for development. Contact us today at contact@codeflixweb.com and let’s create something amazing together!</p>
            </div>
            
          </div>
          <div className="why_us">
            <div className="wrapper">
              <h4>Benefits of Working with CodeFlix</h4>
              <div className="col_row">
                <div
                  className="col_item"
                  style={{
                    backgroundImage: `url(./assets/images/portfolio/usbg1.svg)`,
                  }}
                >
                  <div className="icon">
                    <img src="./assets/images/portfolio/us5.svg" alt="" />
                  </div>
                  <hr />
                  <h3>End-to-End Solutions</h3>
                  <p>
                    From ideation to deployment, we handle every aspect of the
                    development process.
                  </p>
                </div>
                <div
                  className="col_item"
                  style={{
                    backgroundImage: `url(./assets/images/portfolio/usbg2.svg)`,
                  }}
                >
                  <div className="icon">
                    <img src="./assets/images/portfolio/us6.svg" alt="" />
                  </div>
                  <hr />
                  <h3>Agile Methodology</h3>
                  <p>
                    Ensuring flexibility and faster delivery without compromising on
                    quality.
                  </p>
                </div>
                <div
                  className="col_item"
                  style={{
                    backgroundImage: `url(./assets/images/portfolio/usbg3.svg)`,
                  }}
                >
                  <div className="icon">
                    <img src="./assets/images/portfolio/us7.svg" alt="" />
                  </div>
                  <hr />
                  <h3>Experienced Team</h3>
                  <p>
                    A skilled team of developers, designers, and project managers
                    dedicated to your success.
                  </p>
                </div>
                <div
                  className="col_item"
                  style={{
                    backgroundImage: `url(./assets/images/portfolio/usbg4.svg)`,
                  }}
                >
                  <div className="icon">
                    <img src="./assets/images/portfolio/us8.svg" alt="" />
                  </div>
                  <hr />
                  <h3>Client-Centric Approach</h3>
                  <p>
                    Regular communication and collaboration to align the project
                    with your vision.
                  </p>
                </div>
              </div>
           <br />
            </div>
                  </div>
                <div className="let_build">
                    <div className="wrapper">
                    <h4>Let’s Build <span> Your App Together </span></h4>
                  
                  <p>
                    Whether you’re a startup looking to disrupt the market or an
                    established enterprise aiming to enhance operational efficiency,
                    CodeFlix is here to bring your vision to life. Let’s create a
                    custom mobile app that drives results and delights your users.{" "}
                    <br />
                    Contact Us today to get started on your mobile app development
                    journey.
                  </p>
                    </div>
                </div>
        </>
      );
};
export default WireframingPrototyping;
